import Close from "@mui/icons-material/Close";

import "moment/locale/sv";
//import moment from "moment";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { counties, kommuner } from "components/kommuner";
import LocationSelect from "components/LocationSelect";
import Notification from "components/Notification";
import { validateForm } from "components/validateForm";
import useUserProfile from "customhooks/useUserProfile";
import { default as React, useEffect, useState } from "react";
import { getCategories, getCategoryById } from "./categoryHelper";
import theme from "./mainTheme";
import createSubscription from "../utils/createSubscription";

export default function CreateSubscriptionDialog(props) {
  const [category, setCategory] = useState("bygg");
  const [county, setCounty] = useState(" - ");
  const [municipality, setMunicipality] = useState(" - ");

  const userProfile = useUserProfile();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { isOpen, closeDialog, closeAfterCreate, refreshFunc } = props;

  async function handleSubmit() {
    if (userProfile) {
      const cat = getCategoryById(category);
      const categoryName = cat.label;

      createSubscription(
        userProfile.id,
        category,
        county,
        municipality,
        userProfile.email,
        categoryName
      )
        .then(() => {
          const postpone = () => {
            if (refreshFunc) {
              refreshFunc({ userId: userProfile.id });
            }
          };
          setTimeout(postpone, 1000);
          closeAfterCreate();
        })
        .catch((err) =>
          console.log("Error in CreateSubscriptionDialog: ", err)
        );
    }
  }
  const municipalitiesOrg = kommuner.filter((kommun) => {
    if (kommun.admin === county) {
      return true;
    }
    return false;
  });
  const municipalities = municipalitiesOrg.map((kommun) => {
    return kommun.name;
  });
  municipalities.push(" - ");
  municipalities.sort();

  const heading = "SKAPA BEVAKNING";
  const buttonText = "SKAPA BEVAKNING";

  return (
    <>
      <div>
        <ThemeProvider theme={theme}>
          <Dialog
            open={isOpen}
            onClose={closeDialog}
            aria-labelledby="form-dialog-title"
            fullScreen={fullScreen}
            PaperProps={{
              style: {
                overflowY: "visible",
              },
            }}
          >
            {!fullScreen && (
              <DialogTitle id="form-dialog-title">{heading}</DialogTitle>
            )}
            {fullScreen && (
              <AppBar
                style={{ position: "relative", marginBottom: theme.spacing(2) }}
              >
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={closeDialog}
                    aria-label="close"
                  >
                    <Close />
                  </IconButton>
                  <Typography
                    variant="subtitle1"
                    style={{
                      marginLeft: theme.spacing(2),
                      flex: 1,
                    }}
                  >
                    {heading}
                  </Typography>

                  <Button
                    color="inherit"
                    autoFocus
                    variant="outlined"
                    onClick={handleSubmit}
                  >
                    {buttonText}
                  </Button>
                </Toolbar>
              </AppBar>
            )}
            <DialogContent>
              <div>
                <Grid container>
                  <Grid item xs={12} sm={12}>
                    <FormControl
                      variant="outlined"
                      color="primary"
                      style={{
                        position: "relative",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <InputLabel id="category">Kategori</InputLabel>
                      <Select
                        native
                        label="Välj kategori"
                        value={category}
                        onChange={(event) => {
                          setCategory(event.target.value);
                        }}
                      >
                        {Object.keys(getCategories()).map(function (
                          categoryId
                        ) {
                          const category = getCategoryById(categoryId);

                          return (
                            <option key={categoryId} value={categoryId}>
                              {category.label}
                            </option>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <LocationSelect
                      label="Välj län"
                      options={counties}
                      value={county}
                      onChange={(value) => {
                        setMunicipality(" - ");
                        setCounty(value);
                      }}
                    />
                    <br />
                    <LocationSelect
                      label="Välj kommun"
                      options={municipalities}
                      value={municipality}
                      onChange={(value) => {
                        setMunicipality(value);
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog} color="primary">
                Avbryt
              </Button>
              <Button variant="outlined" color="primary" onClick={handleSubmit}>
                {buttonText}
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    </>
  );
}

function SubCategories(props) {
  const categoryId = props.categoryId;
  const values = props.values;
  const onChange = props.onChange;
  if (!categoryId) {
    return null;
  }
  const categoryObject = getCategoryById(categoryId);
  if (!categoryObject) {
    return null;
  }

  if (categoryObject.subCategories.length === 0) {
    return null;
  }

  const asdf = function (name, status) {
    let newValues = values.map((v) => v);
    if (status === false) {
      newValues = values.filter((v) => v !== name);
    } else if (status === true) {
      newValues.push(name);
    }
    onChange(newValues);
  };
  return (
    <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
      <div>
        {categoryObject.subCategories.map(function (sub) {
          return (
            <label
              key={sub}
              style={{
                border: "1px solid black",
                display: "inline-block",
                marginRight: "20px",
                marginTop: "10px",
                borderRadius: "10px",
                padding: "10px",
                whiteSpace: "nowrap",
              }}
            >
              <Checkbox
                key={sub}
                id={sub}
                checked={values.includes(sub)}
                onChange={(event) => asdf(sub, event.target.checked)}
              />
              {sub}
            </label>
          );
        })}
      </div>
    </FormControl>
  );
}
